// import style
import './Error.css';

// import assets
import serverError from 'Assets/Image/Api/server-error.svg';
import serverErrorOne from 'Assets/Image/Api/server-error-one.svg';
import serverError001 from 'Assets/Image/Api/server-error-001.svg';        
const LoadingAnimation = ({error, showErrorSrc}) => {
  
  return (
    <div className='mues_row_center error_container'>
      <div className='error_vector_container'>
        {!showErrorSrc && error?.status===500 && <img src={serverError} 
        alt="vector-container" loading='lazy'  />}
        {(!showErrorSrc && (error?.status===400 || error?.status===404 || error?.status===403)) && <img src={serverErrorOne} 
        alt="vector-container" loading='lazy'  />}
        {(!showErrorSrc && (error?.status==="FETCH_ERROR" || error?.status==="PARSING_ERROR")) && <img src={serverError001} 
        alt="vector-container" loading='lazy'  />}
      </div>
      {error?.status===500 && <h1 className='error_message'>Opps! Something went wrong on our end. Please try again later.</h1>}
      {error?.status===400 && <h1 className='error_message'>Opps! Something went wrong with your request. Please try again later.</h1>}
      {error?.status===404 && <h1 className='error_message'>Opps! The requested resource was not found. Please try again later.</h1>}
      {error?.status===403 && <h1 className='error_message'>Opps! The requested resource was not found. Please try again later.</h1>}
      {error?.status==="FETCH_ERROR" && <h1 className='error_message'>Fail to fetch from server</h1>}
      {error?.status==="PARSING_ERROR" && <h1 className='error_message'>Opps! Server is down. Please try again later.</h1>}
    </div>
  )
}

export default LoadingAnimation